import React, {Component} from 'react';
import {
  Link
} from 'react-router-dom';

import './clientBusinessNav.css';

class Nav extends Component {
  render () {
    return (
      <div className="client-business-info-nav clearfix">
        <div className="wrapper">
          <ul className="clearfix">
            <li className={this.props.params.type === 'client-business-info' ? 'active' : ''}>
              <Link to="/dashboard/clients/client-business-info">
                CLIENT/BUSINESS UNIT
              </Link>
            </li>
            <li className={this.props.params.type === 'users' ? 'active' : ''}>
              <Link to="/dashboard/clients/users">
                USERS
              </Link>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/ClientBusinessInfoAndUser/Nav/Nav.jsx